import { render } from "./PrescriptionRejected.vue?vue&type=template&id=632ee5c9"
import script from "./PrescriptionRejected.vue?vue&type=script&lang=js"
export * from "./PrescriptionRejected.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__